import React from 'react'
import {
	Box,
	Card,
	CardActionArea,
	CardContent,
	Chip,
	Skeleton,
	Stack,
	Typography,
} from '@mui/material'
import { useGetVacanciesQuery } from '../store/api/vacanciesApi'
import { useNavigate } from 'react-router-dom'

const Vacancies = () => {
	const { data, isLoading, isSuccess } = useGetVacanciesQuery()
	const navigate = useNavigate()

	return (
		<Stack spacing={1}>
			{!isLoading &&
				data &&
				(data.length > 0 ? (
					data.map((vacancy) => (
						<Card key={vacancy.id}>
							<CardActionArea
								onClick={() => navigate(`/vacancies/${vacancy.id}`)}
							>
								<CardContent>
									<Box>
										<Typography variant="h5">{vacancy.title}</Typography>
										<Typography sx={{ color: 'text.secondary', mb: 1.5 }}>
											{vacancy.company}
										</Typography>
									</Box>
									<Stack direction="row" spacing={1}>
										{vacancy.must_have_skills.map((skill, index) => (
											<Chip key={index} label={skill} />
										))}
									</Stack>
								</CardContent>
							</CardActionArea>
						</Card>
					))
				) : (
					<Typography sx={{ textAlign: 'center' }}>
						Вакансії відсутні
					</Typography>
				))}
			{isLoading && (
				<>
					<Skeleton variant="rectangular" width={'100%'} height={'132px'} />
					<Skeleton variant="rectangular" width={'100%'} height={'132px'} />
					<Skeleton variant="rectangular" width={'100%'} height={'132px'} />
					<Skeleton variant="rectangular" width={'100%'} height={'132px'} />
				</>
			)}
		</Stack>
	)
}

export default Vacancies
